<template>
    <van-empty image="error" description="认证失败，无法访问系统资源"/>
</template>
<script>
    import {Empty} from 'vant';

    export default {
        components: {[Empty.name]: Empty},
        data() {
            return {}
        }
    }
</script>
<style scoped></style>
